import React, { memo, useCallback, useMemo } from 'react';
import { AlertViewNew } from 'design-system/AlertViewNew';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { useAppSelector } from 'store/hooks';
import { formatStringList } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectDuplicateGroups } from '../selectors';
import { getSubscriptionName } from '../utils/subscriptionName';
const strings = {
    title: 'Possible duplicate payment',
    action: 'Review',
    paid: (names) => `You may be paying for ${names} twice`,
    // Basic users can't see every row, so the copy never names a merchant.
    basicOne: 'You might be paying twice for a subscription',
    basicMany: (count) => `You might be paying twice for ${count} of your subscriptions`,
};
const PossibleDuplicateBanner = ({ subscriptionId, style, noMargin, }) => {
    const allGroups = useAppSelector(selectDuplicateGroups);
    const groups = useMemo(() => subscriptionId === undefined
        ? allGroups
        : allGroups.filter((group) => group.some(({ id }) => id === subscriptionId)), [allGroups, subscriptionId]);
    const { isUnlockedForSpace, onPressUpgrade } = useShouldShowUpgrade({
        benefitId: 'recurringPayments',
    });
    const navigation = useMainStackNavigation();
    const onReview = useCallback(() => {
        navigation.navigate('DuplicateReview', {
            subscriptionIds: subscriptionId === undefined
                ? groups.map(([first]) => first.id)
                : [subscriptionId],
        });
    }, [navigation, groups, subscriptionId]);
    const subTitle = useMemo(() => {
        if (!isUnlockedForSpace) {
            return groups.length === 1
                ? strings.basicOne
                : strings.basicMany(groups.length);
        }
        const names = groups.map(([first]) => getSubscriptionName(first));
        return strings.paid(formatStringList([...new Set(names)].filter(Boolean)));
    }, [groups, isUnlockedForSpace]);
    if (!groups.length)
        return null;
    return (<AlertViewNew type="info" title={strings.title} subTitle={subTitle} action={strings.action} onPress={isUnlockedForSpace ? onReview : onPressUpgrade} style={style} noMargin={noMargin} testID="possible-duplicate-banner"/>);
};
export default memo(PossibleDuplicateBanner);
